import React, { useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { BotIcon, DownArrowIcon, NewTabLinkIcon, UpArrowIcon } from "../icons";
import { BotResponse } from "../interface";
import { beautifyMessage } from "../utils/common";

const BotMessage: React.FC<{
  data: BotResponse;
  isResponseLoading: boolean;
  showDisclaimer: boolean;
}> = ({ data, isResponseLoading, showDisclaimer }) => {
  const [showCitations, setShowCitations] = useState(false);


  const toggleCitations = () => {
    setShowCitations(!showCitations);
  };

  return (
    <div className="message-container">
      <div className="bot-message">
        <span>
          <div className="icon">
            <BotIcon />
          </div>
          <div className="text">
            {!data?.response ? (
              <ThreeDots color="#FFFFFF" height={40} width={40} radius={9} />
            ) : (
              <>
                <p>{beautifyMessage(data.response)}</p>
                {data.sources.length > 0 && (
                  <div className="meta-list">
                    {showCitations ? (
                      <>
                        {data.sources.map((source, index) => (
                          <div className="meta-data" key={index}>
                            <p className="meta-item">
                              <b>Reference {index + 1}:</b>{" "}
                              <a
                                href={source.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 underline"
                              >
                                {source.title} <NewTabLinkIcon />
                              </a>
                            </p>
                          </div>
                        ))}
                        <div className="meta-data end">
                          <button
                            className="toggle-citations"
                            onClick={toggleCitations}
                          >
                            Hide Citations <UpArrowIcon />
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="meta-data end">
                        <button
                          className="toggle-citations text-[white]"
                          onClick={toggleCitations}
                        >
                          View Citations <DownArrowIcon />
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </span>
        {!isResponseLoading && showDisclaimer && (
          <div className='chatbot-disclaimer' >
            <p>b1Assistant may provide incomplete or inaccurate information.</p>
            <p>Please verify details with the official bank documentation.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BotMessage;
